<!-- Form -->
@if (titleForm) {
  <medsurf-design-form-control-form
    [formGroup]="titleForm"
    (onSubmit)="onSubmit()">
    <!-- Title -->
    <medsurf-design-form-control-input-text [formField]="false"
      [inputClass]="FlatModels.TextDesignModels.TextDesignClass.SLIDE_TITLE"
      [control]="titleForm.controls.title"
      [placeholder]="'global.slide_title'"
    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
  </medsurf-design-form-control-form>
}
